import hosts from '../hosts';
import request from '..';

export class ChannelController {
  static getConfiguration = ({ channel }) =>
    request({
      path: `/promoters/${channel}/booking-plugin`,
      baseUrl: hosts.MONOLITH,
    });
}
